import * as React from 'react';

function SvgBike(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        d="M11.8 6c.73 0 1.41.42 1.75 1.08l1.39 2.71 3.05 1.42-1.07 1.83-3.06-1.48a2 2 0 01-.79-.7l-.7-1.07-1 2.47 2.73 2.03a1 1 0 01.39.63l.93 5.4-1.83.52-1.67-4.81-3.01-1.4a2.5 2.5 0 01-1.14-3.47l2.25-4.12A2 2 0 0111.77 6zm8.58 6.84a3.87 3.87 0 110 7.74 3.87 3.87 0 010-7.74zm-16.26 0a3.87 3.87 0 110 7.74 3.87 3.87 0 010-7.74zm16.26 1.5a2.37 2.37 0 100 4.74 2.37 2.37 0 000-4.74zm-16.26 0a2.37 2.37 0 100 4.74 2.37 2.37 0 000-4.74zM12.95 1.9a1.85 1.85 0 110 3.7 1.85 1.85 0 010-3.7z"
      />
    </svg>
  );
}

export default SvgBike;
